<template>
<div>
  <nav
        class="navbar is-fixed-top is-white is-transparent"
        role="navigation"
        aria-label="main navigation"
      >
        <div class="container">
          <div class="">
            <p class="navbar-item">
              <span>
                <img
                  :src="$t('logoUrl')"
                  alt="logo"
                  style="height:40px; margin-top: 5px; max-height: 3rem!important;"
                >
              </span>
            </p>
          </div>
        </div>
      </nav>

  <div class="registration" id="signup">
    <div class="box">
      <div class="has-text-centered" >
    <h2 class="title is-2" style="margin-top: 1.5rem;font-size: 2.3rem;padding-bottom: 2rem;">{{ $t('Signup.title') }}</h2>
      </div>
      <div class="columns is-vcentered is-gapless is-multiline">
        <div class="column is-hidden-mobile is-5 has-text-centered">
          <!-- <h2 class="title is-4 is-hidden-mobile">{{ $t('Signup.moto') }}</h2> -->
          <div class="heroImage"></div>
        </div>
        <div class="column is-hidden-mobile">
          <div class="split-divider"></div>
        </div>
        <div class="column is-5">
          <form>
            <div class="field">
              <label class="label">{{ $t('Signup.email') }}</label>
              <div class="control">
                <input class="input" type="email" v-model="username" required>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t('Signup.pwd') }}</label>
              <div class="control">
                <input class="input" type="password" v-model="pass" required>
              </div>
            </div>
            <button type="button"
              class="button is-fullwidth btn-cta"
              @click="signup"
              :class="{'is-loading':clicked}"
              style="font-size: 22px;font-weight: 600;border: 2px solid #fda43c;margin: 2rem 0 0.5rem 0;"
            >{{ $t('Signup.startFreeTrial') }}</button>
          <p v-if="message" class="message">{{ message }}</p>
          </form>
          <div class="has-text-centered">
          <p style="margin-top: 1rem;">{{ $t('Signup.registered') }}  <a :href="'https://create.' + $t('domain') + '/login'">{{ $t('Login.login') }}</a></p>
        </div>
      </div>
      
        
      </div>
    </div>
  </div>
</div>
</template>

<script>
import api from "../api";

export default {
  // title: ({ $t }) => $t('title'),
  components: {},
  data() {
    return {
      username: "",
      email: "",
      pass: "",
      message: "",
      clicked: false
    };
  },
  methods: {
    signup() {
      this.$ma.trackEvent({category: 'event', action: 'Sign-up button clicked', properties: {username: this.username}})

      this.message = ""
      if (!validateEmail(this.username)) {
        this.message = this.$t('Signup.checkEmail')
        return
      }
      else if (this.pass.length < 6) {
        this.message = this.$t('Signup.pwdShort')
        return
        }
      // else if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(this.pass)) {
      //   this.message = this.$t('Signup.pwdMustHave')
      //   console.log(this.message)
      //   return
      //   }
      // else if (this.pass.search(/[0-9]/i) < 0) {
      //   this.error = this.$t('Signup.pwdMustHaveDigits')
      //   return
      //   }

      this.clicked = true;
      this.$cognitoAuth.signup(this.username.toLowerCase().trim(), this.username.toLowerCase().trim(), this.pass, err => {
        if (err) {
          console.log(err)
          if (err.code == "UsernameExistsException") {
            this.message = this.$t('Signup.emailUsed')
          }
          else {
            this.message = this.$t('Signup.error')
          }
            api.sendNotification({message: 'Error during signup. Email: '+ this.username + ", pwd: " + this.pass + ", message: " + err.message})

          this.clicked = false;
        } else {
          console.log("Signup successful");
          if (this.$metrika) {
          this.$metrika.reachGoal(137533003)
          this.$metrika.reachGoal("signup1")
          }
          this.$ma.trackEvent({category: 'event', action: 'Sign-up', properties: {username: this.username, lang: this.$i18n.locale}})
          this.$ma.setAlias(this.username)
          localStorage.clear();
          this.$cognitoAuth.signin(this.username.toLowerCase().trim(), this.pass, (err, result) => {
            if (err) {
              this.error = err;
              this.clicked = false;
              console.log(result);
            } else {
              this.$ma.setUserProperties({userId: this.username, $email: this.username, lang: this.$i18n.locale})
              this.$router.replace(this.$route.query.redirect || "/signup_1");
            }
          });
        }
      });
    }
  },
  mounted() {
    this.$title = this.$t('title') + " | " + this.$t('Signup.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
    
    
  }
};

function validateEmail(email) 
          {
              // eslint-disable-next-line
              const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              var result = regex.test(email);

              console.log("Email valid: " + result)
              return result
          }
</script>


<style scoped>
.message {
  background: #FACDCD;
  color: #E66A6A;
  margin: 10px 0;
  padding: 5px 10px;
}

.button:active, .button.is-active {
    color: #fff;
}

@media screen and (max-width: 768px) {
  #signup .box {
    box-shadow: none!important;
    padding: 5rem 2rem;
  }
  #signup {
    padding-top: 0;
}
 #signup form {
    padding-top: 1rem;
}
}
</style>

